import React, { useRef, useState } from "react";
import { Box, IconButton, Popover, Typography } from "@material-ui/core";
import useStyles from "./styles";
import { ExpandMore } from "@material-ui/icons";
import StatusCompleted from "Assets/images/summary-stats-completed.svg";
import StatusPending from "Assets/images/summary-stats-pending.svg";
import UserListPopover from "./UserListPopOver";
import { updateOrangeDotStatus } from "GraphQL/mutation/targetReview";
import { useMutation } from "@apollo/client";
import { surveySummaryState } from "Recoil/Checkins/atom";
import { useSetRecoilState } from "recoil";
import { surveySummarySelector } from "Recoil/Checkins/selector";

const CheckinSummaryStats = ({
  completedUsers,
  totalUsers,
  totalUsersList,
  average,
  targetId,
  checkinId,
  checkinType,
}) => {
  const classes = useStyles();
  const inprogressCount =
    totalUsers - completedUsers >= 0 ? totalUsers - completedUsers : 0;
  const [anchorEl, setAnchorEl] = useState(null);
  const [statusType, setStatusType] = useState("");
  const [updateOrangeDotRatingStatus] = useMutation(updateOrangeDotStatus);
  const setSurveySummaryData = useSetRecoilState(surveySummarySelector);

  const handleClick = (event, status) => {
    setAnchorEl(event.currentTarget);
    setStatusType(status);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOrangeDot = (userListData) => {
    const respondedIds = [];
    const checkIsHighlight = userListData?.some((res) => res?.isNewHighlight);
    userListData?.forEach((item) => {
      if (item?.isNewHighlight) {
        respondedIds.push(item?.userId);
      }
    });
    if (checkIsHighlight) {
      updateOrangeDotRatingStatus({
        variables: {
          input: {
            targetid: targetId,
            userid: respondedIds,
            checkinId: [checkinId],
            checkinType: checkinType ? checkinType.toLowerCase() : null,
            isNewHighlighted: true,
          },
        },
      })
        .then(() => {
          setTimeout(() => {
            setSurveySummaryData((list) => {
              const surveySummaryValue = [...list?.totalUsersList];
              const result = surveySummaryValue.map((item) => {
                if (item?.checkInStatus === "COMPLETE") {
                  return { ...item, isNewHighlight: false };
                }
                return item;
              });
              return { ...list, totalUsersList: result };
            });
          }, 4000);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const containerRef = useRef();
  const checkIsNew =
    totalUsersList?.length > 0 && totalUsersList?.some((res) => res?.isNew);

  return (
    <Box className={classes.root}>
      <Box display="flex" className={classes.subSection}>
        <Box width="50%" textAlign="center" p={2}>
          <Box
            data-testid="handleClick"
            inputProps={{ "data-testid": "handleClick" }}
            aria-describedby={id}
            // onClick={handleClick}
            onClick={(e) =>
              inprogressCount &&
              totalUsersList?.length &&
              handleClick(e, ["INPROGRESS", "OVERDUE"])
            }
            className={classes.stats}
            display="flex"
            alignItems="center"
            justifyContent="center"
            mb={0.5}
          >
            <img src={StatusPending} alt="status pending" />
            <Typography
              variant="body2"
              component="span"
              className="font-20 font-semibold"
            >
              {inprogressCount || 0}
            </Typography>
            {inprogressCount && totalUsersList?.length ? <ExpandMore /> : null}
          </Box>

          <Typography variant="body2" className="f-light-gray font-12">
            Pending
          </Typography>
        </Box>
        <Box width="50%" textAlign="center" p={2}>
          <Box
            className={classes.stats}
            display="flex"
            alignItems="center"
            justifyContent="center"
            data-testid="open-modal"
            onClick={(e) =>
              completedUsers &&
              totalUsersList?.length &&
              handleClick(e, ["COMPLETE"])
            }
            mb={0.5}
          >
            <img src={StatusCompleted} alt="status pending" />
            <Typography
              variant="body2"
              component="span"
              className="font-20 font-semibold"
            >
              {completedUsers || 0}
            </Typography>
            {/* Add orange dot/highlight code here */}
            {completedUsers && totalUsersList?.length ? (
              <IconButton
                size="small"
                className={`${checkIsNew ? classes.dotIndicator : ""} p0 ${
                  classes.arrowBtn
                }`}
                onClick={() => handleOrangeDot(totalUsersList)}
              >
                <ExpandMore />
              </IconButton>
            ) : null}
          </Box>
          <Typography variant="body2" className="f-light-gray font-12">
            Completed
          </Typography>
        </Box>
      </Box>
      {average !== null ? (
        <Box className={classes.average} p={0.8} textAlign="center">
          <Typography variant="body2" className="font-13 font-semibold">
            Average {average?.toFixed(0)}%
          </Typography>
        </Box>
      ) : null}
      <Popover
        data-testid="handleClose"
        container={containerRef.current}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <UserListPopover
          userList={totalUsersList?.filter((res) =>
            statusType.includes(res?.checkInStatus)
          )}
        />
      </Popover>
    </Box>
  );
};

export default CheckinSummaryStats;
